var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_350_495)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9998 27.75H25.9998C25.5898 27.75 25.2498 27.41 25.2498 27C25.2498 26.59 25.5898 26.25 25.9998 26.25H26.9998C27.6898 26.25 28.2498 25.69 28.2498 25V15.75H19.9998C18.8198 15.75 17.7398 16.39 17.1598 17.42C16.9598 17.78 16.4998 17.91 16.1398 17.71C15.7798 17.51 15.6498 17.05 15.8498 16.69C16.6898 15.19 18.2798 14.25 19.9998 14.25H28.9998C29.4098 14.25 29.7498 14.59 29.7498 15V25C29.7498 26.52 28.5198 27.75 26.9998 27.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 33.75H32C31.59 33.75 31.25 33.41 31.25 33C31.25 32.31 30.69 31.75 30 31.75C29.31 31.75 28.75 32.31 28.75 33C28.75 33.41 28.41 33.75 28 33.75H24C23.59 33.75 23.25 33.41 23.25 33C23.25 32.31 22.69 31.75 22 31.75C21.31 31.75 20.75 32.31 20.75 33C20.75 33.41 20.41 33.75 20 33.75H19C16.93 33.75 15.25 32.07 15.25 30C15.25 29.59 15.59 29.25 16 29.25C16.41 29.25 16.75 29.59 16.75 30C16.75 31.24 17.76 32.25 19 32.25H19.35C19.68 31.1 20.74 30.25 22 30.25C23.26 30.25 24.32 31.1 24.65 32.25H27.36C27.69 31.1 28.75 30.25 30.01 30.25C31.27 30.25 32.33 31.1 32.66 32.25H33C34.24 32.25 35.25 31.24 35.25 30V27.75H33C32.04 27.75 31.25 26.96 31.25 26V23C31.25 22.04 32.03 21.25 33 21.25L31.93 19.38C31.71 18.99 31.29 18.75 30.84 18.75H29.75V25C29.75 26.52 28.52 27.75 27 27.75H26C25.59 27.75 25.25 27.41 25.25 27C25.25 26.59 25.59 26.25 26 26.25H27C27.69 26.25 28.25 25.69 28.25 25V18C28.25 17.59 28.59 17.25 29 17.25H30.84C31.83 17.25 32.74 17.78 33.23 18.64L34.94 21.63C35.07 21.86 35.07 22.15 34.94 22.38C34.81 22.61 34.56 22.75 34.29 22.75H33C32.86 22.75 32.75 22.86 32.75 23V26C32.75 26.14 32.86 26.25 33 26.25H36C36.41 26.25 36.75 26.59 36.75 27V30C36.75 32.07 35.07 33.75 33 33.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 35.75C20.48 35.75 19.25 34.52 19.25 33C19.25 31.48 20.48 30.25 22 30.25C23.52 30.25 24.75 31.48 24.75 33C24.75 34.52 23.52 35.75 22 35.75ZM22 31.75C21.31 31.75 20.75 32.31 20.75 33C20.75 33.69 21.31 34.25 22 34.25C22.69 34.25 23.25 33.69 23.25 33C23.25 32.31 22.69 31.75 22 31.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 35.75C28.48 35.75 27.25 34.52 27.25 33C27.25 31.48 28.48 30.25 30 30.25C31.52 30.25 32.75 31.48 32.75 33C32.75 34.52 31.52 35.75 30 35.75ZM30 31.75C29.31 31.75 28.75 32.31 28.75 33C28.75 33.69 29.31 34.25 30 34.25C30.69 34.25 31.25 33.69 31.25 33C31.25 32.31 30.69 31.75 30 31.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 27.75H33C32.04 27.75 31.25 26.96 31.25 26V23C31.25 22.04 32.04 21.25 33 21.25H34.29C34.56 21.25 34.81 21.39 34.94 21.63L36.65 24.63C36.71 24.74 36.75 24.87 36.75 25V27C36.75 27.41 36.41 27.75 36 27.75ZM33 22.75C32.86 22.75 32.75 22.86 32.75 23V26C32.75 26.14 32.86 26.25 33 26.25H35.25V25.2L33.85 22.75H33Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 21.75H16C15.59 21.75 15.25 21.41 15.25 21C15.25 20.59 15.59 20.25 16 20.25H22C22.41 20.25 22.75 20.59 22.75 21C22.75 21.41 22.41 21.75 22 21.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 24.75H16C15.59 24.75 15.25 24.41 15.25 24C15.25 23.59 15.59 23.25 16 23.25H20C20.41 23.25 20.75 23.59 20.75 24C20.75 24.41 20.41 24.75 20 24.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 27.75H16C15.59 27.75 15.25 27.41 15.25 27C15.25 26.59 15.59 26.25 16 26.25H18C18.41 26.25 18.75 26.59 18.75 27C18.75 27.41 18.41 27.75 18 27.75Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_350_495",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_350_495"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_350_495",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogistics);
export default __webpack_public_path__ + "static/media/logistics.1beff559afa384473dd4ad55a57c50e1.svg";
export { ForwardRef as ReactComponent };